import { Button, type ButtonProps } from "./core/Button";
import { clsx } from "./core/clsx";
import styles from "./TextButton.module.css";

export const TextButton: React.FC<ButtonProps> = ({ className, variant = "contained", ...props }) => {
  return <Button className={clsx(styles.textButton, className as string)} variant={variant} {...props} />;
};
